<script lang="ts">
    
    import type { Readable, Writable } from "svelte/store";
    import type { State } from "../Model/State";

    export let store: Writable<any> | Readable<any> | State;
    export let defaultText = 'Sin texto';

</script>

<span
    contenteditable="true"
    bind:textContent={$store}
    style="--default-text: '{defaultText}'"
    class:is-empty={!$store}
    on:keyup|preventDefault></span>

<style lang="scss">

    [contenteditable] {
        outline: none;
        display: inline-block;

        &.is-empty {
            &::before {
                content: var(--default-text, 'Sin texto');
                color: #888;
            }
        }
    }    

</style>
